//export const host = "";
// :
export const host =  "https://api.sarasewa.com";
// export const host =  "http://localhost:3000";
export const role = localStorage.getItem("role");
export const username = localStorage.getItem("username");
export const branchCode = localStorage.getItem("branchCode");
